<template>
  <!-- ======= Our Clients Section ======= -->
  <section id="clients" class="clients pb-0">
    <div class="container">
      <div class="section-title">
        <h2>Services we provide</h2>
        <p>
          Expert Web App Development Services to Take Your Business to the Next
          Level.
        </p>
      </div>

      <div class="clients-slider swiper">
        <div class="swiper-wrapper align-items-center">
          <div class="swiper-slide">
            <img
              src="https://objectstorage.ca-toronto-1.oraclecloud.com/p/jE02KCLipZSKqdPxfle5ABFxoo3kkhQaCZySIYDoeGA5vq21F6brBA1inVn0dds4/n/yzfveo9zjrvn/b/bucket-20230109-1321/o/codebridge/content-management-system-development.jpg"
              class="img-thumbnail"
              alt="picture"
            />
          </div>
          <div class="swiper-slide">
            <img
              src="https://objectstorage.ca-toronto-1.oraclecloud.com/p/jE02KCLipZSKqdPxfle5ABFxoo3kkhQaCZySIYDoeGA5vq21F6brBA1inVn0dds4/n/yzfveo9zjrvn/b/bucket-20230109-1321/o/codebridge/e-commerce.jpg"
              class="img-thumbnail"
              alt="picture"
            />
          </div>
          <div class="swiper-slide">
            <img
              src="https://objectstorage.ca-toronto-1.oraclecloud.com/p/jE02KCLipZSKqdPxfle5ABFxoo3kkhQaCZySIYDoeGA5vq21F6brBA1inVn0dds4/n/yzfveo9zjrvn/b/bucket-20230109-1321/o/codebridge/web-app-design.jpg"
              class="img-thumbnail"
              alt="picture"
            />
          </div>
          <div class="swiper-slide">
            <img
              src="https://objectstorage.ca-toronto-1.oraclecloud.com/p/jE02KCLipZSKqdPxfle5ABFxoo3kkhQaCZySIYDoeGA5vq21F6brBA1inVn0dds4/n/yzfveo9zjrvn/b/bucket-20230109-1321/o/codebridge/web-app-development.jpg"
              class="img-thumbnail"
              alt="picture"
            />
          </div>
          <div class="swiper-slide">
            <img
              src="https://objectstorage.ca-toronto-1.oraclecloud.com/p/jE02KCLipZSKqdPxfle5ABFxoo3kkhQaCZySIYDoeGA5vq21F6brBA1inVn0dds4/n/yzfveo9zjrvn/b/bucket-20230109-1321/o/codebridge/web-app-integration.jpg"
              class="img-thumbnail"
              alt="picture"
            />
          </div>
          <div class="swiper-slide">
            <img
              src="https://objectstorage.ca-toronto-1.oraclecloud.com/p/jE02KCLipZSKqdPxfle5ABFxoo3kkhQaCZySIYDoeGA5vq21F6brBA1inVn0dds4/n/yzfveo9zjrvn/b/bucket-20230109-1321/o/codebridge/web-app-maintenance-and-support.jpg"
              class="img-thumbnail"
              alt="picture"
            />
          </div>
        </div>
        <div class="swiper-pagination"></div>
      </div>
    </div>
  </section>
  <!-- End Our Clients Section -->
</template>

<script>
import Swiper, { Navigation, Pagination } from "swiper";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

export default {
  mounted() {
    this.getClientsSlider();
  },
  methods: {
    getClientsSlider() {
      new Swiper(".clients-slider", {
        speed: 400,
        loop: true,
        autoplay: {
          delay: 5000,
          disableOnInteraction: false,
        },
        slidesPerView: "auto",
        pagination: {
          el: ".swiper-pagination",
          type: "bullets",
          clickable: true,
        },
        breakpoints: {
          320: {
            slidesPerView: 2,
            spaceBetween: 40,
          },
          480: {
            slidesPerView: 3,
            spaceBetween: 60,
          },
          640: {
            slidesPerView: 4,
            spaceBetween: 80,
          },
          992: {
            slidesPerView: 6,
            spaceBetween: 120,
          },
        },
        modules: [Navigation, Pagination],
      });
    },
  },
};
</script>

<style lang="scss">
/*--------------------------------------------------------------
# Our Clients
--------------------------------------------------------------*/
.clients .swiper-slide img {
  opacity: 0.5;
  transition: 0.3s;
}

.clients .swiper-slide img:hover {
  opacity: 1;
}

.clients .swiper-pagination {
  margin-top: 40px;
  position: relative;
}

.clients .swiper-pagination .swiper-pagination-bullet {
  width: 12px;
  height: 12px;
  background-color: #fff;
  opacity: 1;
  border: 1px solid $mainLightBlue;
}

.clients .swiper-pagination .swiper-pagination-bullet-active {
  background-color: $mainLightBlue;
}
</style>